import { TFormValue } from '../../add-lenses-step/add-lenses-step-form';

export const getLensesParams = (products: TFormValue[]): TFormValue[] => {
  return products.filter((product) => Number(product.productQuantity) > 0);
};
